import { useRef, useLayoutEffect } from "react";
import iconTrash from "../../assets/icon-trash.svg";

interface TextBlockProps {
  value: string;
  onChange: (value: string) => void;
  onDelete: () => void;
}

export function TextBlock({ value, onChange, onDelete }: TextBlockProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.style.height = "auto";
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div className="flex items-start gap-2">
      <textarea
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Text"
        className="flex-1 text-sm text-text-primary placeholder:text-text-tertiary bg-transparent border-none outline-none leading-[1.5] resize-none min-h-[60px] overflow-hidden"
      />
      <button type="button" onClick={onDelete} className="p-1 shrink-0 hover:opacity-70">
        <img src={iconTrash} alt="Delete block" width={20} height={20} />
      </button>
    </div>
  );
}
